/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AbstractFilterComponent} from '../abstract-filter.component';
import {InputTextComponent} from '../../input/input-text/input-text.component';
import {InputFilterStateModel} from './input-filter-state.model';
import {ReplaySubject} from 'rxjs';

@Component({
    selector: 'app-simple-filter',
    templateUrl: './input-filter.component.html',
    styleUrls: ['../filter.component.css', './input-filter.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputFilterComponent extends AbstractFilterComponent<InputFilterStateModel> {

    @Input() public placeHolder: string;
    @Input() public filterName: string;
    @ViewChild('searchInput') searchInput: InputTextComponent;

    private initialSearchInputValue = new ReplaySubject<string>(1);

    constructor() {
        super();
    }

    emitSearch(): void {
        this.storeState();
        this.filterEvent.emit(this.state);
    }

    resetFilter(): void {
        this.searchInput.deleteInputValue();
    }

    onValueChanges(searchText: string): void {
        this.storeState({
            searchText
        });
    }

    storeState(state?: Partial<InputFilterStateModel>): void {
        super.storeState(state);
        super.storeState({
            isActive: this.state.searchText != null
        });
    }

    initFilter(filter: InputFilterStateModel): void {
        if (filter && filter.searchText != null) {
            this.searchInput.setValue(filter.searchText);
        }
    }
}
